import { createStore, applyMiddleware, compose } from "redux";
import { createEpicMiddleware } from "redux-observable";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import { authMiddleware } from "../middleware/authMiddleware";
import { fetchMiddleWare } from "../middleware/fetchMiddleWare";
import systemNotificationMiddleware from "../middleware/systemNotificationMiddleware.js";
import createDebounce from "redux-debounced";

import thunk from "redux-thunk";

import rootEpic from "./rootEpic";
import rootReducer from "./rootReducer";

const epicMiddleware = createEpicMiddleware();

const persistKey = process.env.REACT_APP_PERSIST_KEY;

const persistConfig = {
  key: persistKey,
  storage: storage,
  stateReconciler: autoMergeLevel2,
  blacklist: [
    "form",
    "pwdCaseSearchReducer",
    "pwdCaseSelectedReducer",
    "caseSearchReducer",
    "appendixReducer",
    "notifications",
    "appReducer",
  ],
};

const pReducer = persistReducer(persistConfig, rootReducer());

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

function configureStore() {
  const store = createStore(
    pReducer,
    composeEnhancers(
      applyMiddleware(
        systemNotificationMiddleware,
        createDebounce(),
        epicMiddleware,
        authMiddleware,
        fetchMiddleWare,
        thunk
      )
    )
  );

  epicMiddleware.run(rootEpic);

  return store;
}

export const store = configureStore();

export const persistor = persistStore(store);
